webpackJsonp([54192777934211],{

/***/ 1495:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"PatientLocationInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"kennelId","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"defaultValue":null,"description":null,"name":"wardId","type":{"kind":"SCALAR","name":"ID","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-patient-location-input-9a44bd09b7ca5ee49c74.js